module.exports = __webpack_public_path__ + "img/direct.90256ef9.png";